import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import HeroSection from '../components/HeroSection/Hero';

const Home = () => {
  return (
    <div>
      <Navbar />
      <HeroSection /> 
    </div>
  )
}


export default Home
